import { useEffect, useState } from "react";
import "../LoginPage.css";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import {
  decruptCipherString,
  decruptCipherJson,
  CustomLoader,
  decryptData,
} from "./CommonLibrary";
import moment from "moment";
import { encryptData } from "./Utils";
import "../componenents/Navbar.css";

function ValidatePage() {
  useEffect(() => {
    let dashboardLocalData = localStorage.getItem("dashboard");
    if (dashboardLocalData) {
      localStorage.removeItem("dashboard");
    }

    let activeNavItemStore = localStorage.getItem("activeNavItem");
    if (activeNavItemStore) {
      localStorage.removeItem("activeNavItem");
    }
  }, []);

  const navigate = useNavigate();

  useEffect(() => {
    let preLogin = localStorage.getItem("preLogin")
      ? localStorage.getItem("preLogin")
      : "";
    if (preLogin) {
      const isLoggedIn = decryptData(preLogin);
      if (isLoggedIn?.toString() !== "Yes") {
        console.error("[BLOCKED REDIRECT] preLogin decrypt failed, isLoggedIn:", isLoggedIn);
        // navigate("/login");
      }
    } else {
      console.error("[BLOCKED REDIRECT] preLogin not found in localStorage");
      // navigate("/login");
    }
  }, [navigate]);

  const [dashboardList, setDashboardList] = useState("");
  const [tokenValue, setTokenValue] = useState("");
  const [notAccess, setNotAccess] = useState(false);
  const [userName, setUserName] = useState("");
  const [loading, setLoading] = useState(true);
  const [accessLevel, setAccessLevel] = useState(true);
  const [hideUserName, setHideUserName] = useState(true);

  var setToken;
  const queryParams = new URLSearchParams(window.location.search);

  setToken = queryParams.get("token");

  useEffect(() => {
    // localStorage.clear();
    const fetchData = async () => {
      axios
        .post(process.env.REACT_APP_BASE_URL + "sso/validate_user", {
          token: setToken,
        })
        .then(function (response) {
          // console.log('[validate_user] raw response.data:', JSON.parse(response.data.data));
          if (response.data.code == 200) {
            let loginData;
            try {
              const rawData = response.data.data || response.data.abc;
              loginData = typeof rawData === 'string' ? JSON.parse(rawData) : rawData;
            } catch (e) {
              console.error('[validate_user] parse error:', e);
              return;
            }
            console.log('loginData: ', loginData);

            if (1 != 1) {
              const redirectUrl = decruptCipherString(
                loginData.data.redirectUrl,
              );
              console.log("redirectUrl: ", redirectUrl);
              if (redirectUrl) {
                // setRedirectTo(redirectUrl);
              }
              localStorage.setItem("uid", loginData.data.userAdminId);
              localStorage.setItem("user", loginData.data.username);
              localStorage.setItem(
                "authToken",
                loginData.data.verificationToken,
              );
              localStorage.setItem("isLoggedIn", loginData.data.redirectUrl);
              localStorage.setItem("tabs", loginData.data.tabs);
              localStorage.setItem("pagesList", loginData.data.pagesList);
              localStorage.setItem("dashboard", loginData.data.dashboard);
              localStorage.setItem("cnId", loginData.data.userAdminId);
              localStorage.setItem("adminId", loginData.data.adminId);
              // const selectedDates = decruptCipherJson(
              //   loginData.data.selectedDates,
              // );
              // const selectedDates = JSON.parse(
              //   loginData.data.selectedDates,
              // );
              // localStorage.setItem(
              //   "selectedDates",
              //   encryptData(
              //     JSON.stringify([
              //       moment(selectedDates.startDate).toDate(),
              //       moment(selectedDates.endDate).toDate(),
              //       moment(selectedDates.ytdStartDate).toDate(),
              //       moment(selectedDates.ytdEndDate).toDate(),
              //     ]),
              //   ),
              // );
            } else if (
              loginData.data.status == 2 ||
              loginData.data.status == 1
            ) {
              localStorage.setItem("switch", response.data.switch);
              // console.log("response.data.switch: ", response.data.switch);
              localStorage.setItem("user", loginData.data.username);
              localStorage.setItem("cnId", loginData.data.cnId);
              localStorage.setItem("adminId", loginData.data.userAdminId);
              // setUserName(decruptCipherString(loginData.data.username));
              setUserName(loginData.data.username);
              setTokenValue(loginData.data.token);
              setDashboardList(loginData.data.dashboardArray);
              setLoading(false);
            } else if (loginData.data.status == 304) {
              setUserName(loginData.data.username);
              setNotAccess(true);
              setLoading(false);
            } else {
              setHideUserName(false);
              setNotAccess(true);
              setLoading(false);
            }
          } else {
            alert("something went wrong");
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    };

    fetchData();
  }, []);

  const loginUser = async (dashboardValue) => {
    // console.log('dashboardValue: ', dashboardValue);

    setLoading(true);
    axios
      .post(process.env.REACT_APP_BASE_URL + "sso/login_dashboard", {
        dashboard: dashboardValue,
        token: tokenValue,
        accesslevel: accessLevel,
      })
      .then(function (response) {
        if (response.data.code == 200) {
          let loginData;
          try {
            const rawData = response.data.data || response.data.abc;
            loginData = JSON.parse(rawData);
          } catch (e) {
            console.error('login_dashboard parse error:', e);
            setLoading(false);
            return;
          }
          const redirectUrl = loginData.data.redirectUrl || "";
          // Save to localStorage
          localStorage.setItem("uid", loginData.data.userAdminId);
          localStorage.setItem("user", loginData.data.username);
          localStorage.setItem("authToken", loginData.data.verificationToken);
          localStorage.setItem("isLoggedIn", loginData.data.redirectUrl);
          localStorage.setItem("tabs", loginData.data.tabs);
          localStorage.setItem("pagesList", loginData.data.pagesList);
          localStorage.setItem("dashboard", loginData.data.dashboard);
          localStorage.setItem("accesslevel", loginData.data.accesslevel);
          localStorage.setItem("cnId", loginData.data.cnId);
          localStorage.setItem("adminId", loginData.data.userAdminId);

          setAccessLevel(loginData.data.accesslevel);

          if (loginData.data.selectedDates) {
            try {
              const selectedDates = decruptCipherJson(loginData.data.selectedDates);
              if (selectedDates) {
                localStorage.setItem(
                  "selectedDates",
                  encryptData(
                    JSON.stringify([
                      moment(selectedDates.startDate).toDate(),
                      moment(selectedDates.endDate).toDate(),
                      moment(selectedDates.ytdStartDate).toDate(),
                      moment(selectedDates.ytdEndDate).toDate(),
                    ]),
                  ),
                );
              }
            } catch (e) {
              console.error("selectedDates parse error:", e);
            }
          }

          const sameOrigin = loginData.data.sameOrigin;
          if (redirectUrl) {
            if (sameOrigin === 1 || sameOrigin === "1" || sameOrigin === true) {
              // Keep loader visible — page is navigating away, no need to hide spinner
              window.location.href = redirectUrl;
            } else {
              // New tab — hide loader so user can keep using this page
              setLoading(false);
              window.open(redirectUrl, "_blank", "noopener,noreferrer");
            }
          } else {
            setNotAccess(true);
            setLoading(false);
          }
        } else {
          setNotAccess(true);
          setLoading(false);
        }
      })
      .catch(function (error) {
        console.error('login_dashboard error:', error);
        setLoading(false);
      });
  };

  if (loading) {
    return (
      <div>
        <CustomLoader />
      </div>
    );
  }

  return (
    <>
      <section className="LoginPage">
        <div className="card-login">
          <div className="card-body">
            <div className="container">
              <div className="row gap-4">
                <div className="col-md-4 ps-0">
                  <img
                    src="https://storecdn.goqii.com/media/store-img/goqii-logo_store.png"
                    className="img-fluid logo-ksa tw-max-h-12"
                    alt=""
                  />
                  <img
                    src="https://appcdn.goqii.com/storeimg/80972_1727955999.png"
                    className="img-fluid logo-ksa tw-max-h-12 tw-ml-2"
                    alt=""
                  />
                </div>
                <div className="col-md">
                  <h1 className="login-title mb-4 ">
                    <span></span>{" "}
                    {/* <div className="col-md-6 px-0">
                      <img
                        src="https://appcdn.goqii.com/storeimg/80972_1727955999.png"
                        className="img-fluid  img-login"
                        alt=""
                      />
                    </div> */}
                  </h1>
                </div>
                {hideUserName && (
                  <div className="col-auto">
                    <div className="dropdown-center">
                      <button
                        className="btn btn-secondary dropdown-toggle profile-dropdown"
                        type="button"
                        data-bs-toggle="dropdown"
                        aria-expanded="false"
                      >
                        <img
                          src="https://storage.googleapis.com/ksabupatest/2024/09/24/dhdjh/898otsm9c0.png"
                          className="profile-images"
                          alt="Profile"
                        />
                        {userName}
                      </button>
                      <ul className="dropdown-menu dropdown-menu-light">
                        <li>
                          <a className="dropdown-item" href="/logout">
                            <i
                              className="bx bx-power-off"
                              style={{ color: "#FF0000" }}
                            ></i>{" "}
                            Log out
                          </a>
                        </li>
                      </ul>
                    </div>
                  </div>
                )}
              </div>

              <div className="row">
                <div className="col-md-12 px-0 mb-2">
                  <div className="form-group">
                    {notAccess ? (
                      <>
                        <div className="row mb-5">
                          <div className="col-md-12 text-center">
                            <img
                              src="https://storage.googleapis.com/ksabupatest/2024/09/24/yurhg/4140jj6978.png"
                              alt=""
                              style={{ height: "240px" }}
                            />
                            <h1
                              className="login-subtitle my-3"
                              style={{ fontWeight: "400" }}
                            >
                              It seems like you're on a secret mission without
                              the right access.
                              <br /> Better call your system administrator to
                              unlock the doors!
                            </h1>
                            <Link
                              to="/login"
                              className="btn btn-primary btn-login"
                            >
                              Ok
                            </Link>
                          </div>
                        </div>
                      </>
                    ) : (
                      <>
                        {dashboardList ? (
                          <>
                            <div className="row mb-4 justify-content-center">
                              <div className="col-md-12">
                                <h1 className="login-subtitle">
                                  Select your App
                                </h1>
                              </div>
                              {dashboardList.map((data, index) => (
                                <div
                                  className="col-md-auto px-4 text-center mb-4"
                                  key={index}
                                >
                                  <button
                                    className="btn btn-light btn-login-box my-1"
                                    onClick={(e) => loginUser(data.value)}
                                  >
                                    <img
                                      src={data.img}
                                      className="img-fluid box-ksa-icon m-auto"
                                      alt=""
                                    />
                                  </button>
                                  <h2 className="mt-1 login-box-title">
                                    {data.text}
                                  </h2>
                                </div>
                              ))}
                            </div>
                          </>
                        ) : (
                          ""
                        )}
                      </>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="powered-by mt-2">
          <img
            src="https://appcdn.goqii.com/storeimg/91809_1719235434.png"
            style={{ height: "42px" }}
            className=""
            alt=""
          />
        </div>
      </section>
    </>
  );
}

export default ValidatePage;